import React, { useState } from 'react'
import Field from '../Field'
import classNames from 'classnames'

const EditableSpanElement = ({
    containerClassName = '',
    valueClassName = '',
    inlineElement: Component,
    inlineElementType = null,
    innerRef,
    value: innerValue,
    onChange = () => {},
    ...props
}) => {
    const [editing, setEditing] = useState(false)
    const [selectValue, setSelectValue] = useState([])
    const onBlur = (event) => {
        setEditing(false)

        if((inlineElementType == 'AsyncInlineSelectElement' || inlineElementType == 'InlineSelectElement') && props.options && typeof innerValue == 'object' ) {
            onChange(props.options.find(option => option.value == selectValue?.value) || selectValue)
        } else if (inlineElementType == 'InputInlineElement') {
            onChange(event)
        } else if (props.options && typeof innerValue == 'object') {
            onChange(props.options.find(option => option.value == selectValue?.value) || selectValue)
        } else if (typeof innerValue == 'object' || props.options) {
            onChange(selectValue)
        } else {
            onChange(event)
        }
    }

    const getChildren = () => {
        if (props.children) {
            return props.children
        } else if (innerValue && typeof innerValue == 'object' && innerValue.label == undefined && innerValue.value == undefined && !innerValue.length) {
            return undefined;
        } else if (!!innerValue && props.children == undefined && typeof innerValue == 'object') {
            return innerValue.label || innerValue.map((value) => (value.label)).join(', ') || undefined
        } else {
            return innerValue
        }
    }

    const getValueOrPlaceholder = () => {
        const value = getChildren();
        if (props.placeholder && (value == undefined || value == null || value == '')) {
            return <span className="text-gray-400">{props.placeholder}</span>
        } else {
            return value
        }
    }

    const onFocus = () => {
        if (!props.disabled) {
            setEditing(true)
            if (typeof innerValue == 'object') {
                setSelectValue(innerValue)
            }
        }
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault()
            onBlur(event)
        }
    };

    return (
        <span
            ref={innerRef}
            tabIndex={0}
            onFocus={onFocus}
            className={classNames([
                'w-full',
                'text-left',
                'cursor-pointer'
            ], containerClassName)}
        >
            { editing ? (
                <Component 
                    onChange={(value) => setSelectValue(value)} 
                    value={typeof innerValue == 'object' ? selectValue : innerValue} 
                    onBlur={(e) => onBlur(e)}
                    onKeyDown={(e) => handleKeyPress(e)}
                    {...props}
                />
            ) : (
                <span
                    className={classNames({
                        'border-b border-gray-300 hover:border-gray-700 border-dashed': !props.disabled && !props.children,
                        'cursor-not-allowed': props.disabled
                    },valueClassName)}
                >
                    { getValueOrPlaceholder() }
                </span>
            ) }
        </span>
    )
}

export const EditableSpan = ({ labelClassName, ...props }) => (
    <Field
      labelClassName={classNames('hover:text-primary cursor-pointer', labelClassName)}
      element={EditableSpanElement}
      { ...props }
    />
)

export default EditableSpan
